import React from 'react';
import { Link } from 'react-router-dom';
import PageWayfinding from '../components/common/PageWayfinding';
import FadeUp from '../components/common/FadeUp';
import {
  getReadyToolsCount,
  getToolsByCategory,
  TOOL_CATEGORY,
  toolSections,
} from '../data/toolsData';
import useDocumentTitle from '../hooks/useDocumentTitle';
import '../components/landing-v2/landing-v2-fonts';
import '../components/landing-v2/landing-v2.css';
import './ToolsPage.css';

const CATEGORY_LABEL = {
  [TOOL_CATEGORY.ADS]: 'Реклама',
  [TOOL_CATEGORY.FINANCE]: 'Финансы',
};

const ToolsPage = () => {
  const toolsCount = getReadyToolsCount();

  useDocumentTitle(`marketDir — все инструменты (${toolsCount})`);

  return (
    <main className="tools-page-shell">
      <PageWayfinding />

      <div className="landing-v2 tools-page-content">
        <FadeUp delay={0}>
          <div className="lv2-section-eyebrow">
            <span className="lv2-section-eyebrow-line" />
            Бесплатные инструменты
          </div>
          <h1 className="lv2-section-title tools-page-title">
            Все <em>инструменты</em>
          </h1>
          <p className="lv2-section-lead lv2-section-lead--tight">
            {toolsCount} калькуляторов и шаблонов. Без регистрации. Результат за 2 минуты.
          </p>
        </FadeUp>

        {toolSections.map((section, sectionIndex) => {
          const categoryTools = getToolsByCategory(section.id);

          return (
            <FadeUp
              key={section.id}
              as="section"
              className={`tools-page-section${sectionIndex > 0 ? ' tools-page-section--separated' : ''}`}
              delay={sectionIndex * 40}
            >
              <h2 className="lv2-section-title tools-page-category-title">
                {section.titlePrefix}
                <em>{section.titleEmphasis}</em>
              </h2>
              <p className="lv2-section-lead lv2-section-lead--tight">{section.lead}</p>
              <div className="lv2-tools-grid tools-page-grid">
                {categoryTools.map((tool) => (
                  <Link key={tool.id} to={`/tools/${tool.slug}`} className="lv2-tc">
                    <div className="lv2-tc-cat">{CATEGORY_LABEL[tool.category]}</div>
                    <div className="lv2-tc-name">{tool.name}</div>
                    <p className="lv2-tc-desc">{tool.description}</p>
                  </Link>
                ))}
              </div>
            </FadeUp>
          );
        })}
      </div>
    </main>
  );
};

export default ToolsPage;
